
export function getCsrfToken() {
    const meta = document.head.querySelector('meta[name=csrf-token]');
    if(!meta) {
        console.error('no csrf-token meta');
        return;
    }
    return meta.getAttribute('content');
}